module.exports = __webpack_public_path__ + "img/storyset-online-document-rafiki.54d38b0b.svg";